export interface Category {
  slug: string;
  name: string;
  en: string;
  icon: string;
  desc: string;
  tagline: string;
}

export const categories: Category[] = [
  {
    slug: "xuangyi",
    name: "悬疑",
    en: "Mystery",
    icon: "ri-eye-off-line",
    desc: "迷雾笼罩的真相，层层抽丝剥茧，让人欲罢不能的悬疑佳作。",
    tagline: "每一帧都暗藏线索",
  },
  {
    slug: "tuili",
    name: "推理",
    en: "Deduction",
    icon: "ri-git-branch-line",
    desc: "严密的逻辑推演与细节推理，陪主角一起破解谜题。",
    tagline: "逻辑与直觉的对决",
  },
  {
    slug: "shaonao",
    name: "烧脑",
    en: "Mind-bending",
    icon: "ri-brain-line",
    desc: "高智商博弈与复杂设定，烧光脑细胞的智力风暴。",
    tagline: "智商不够，经验来凑",
  },
  {
    slug: "fanzhuan",
    name: "反转",
    en: "Twist",
    icon: "ri-refresh-line",
    desc: "剧情急转直下，不到最后一页永远猜不到结局。",
    tagline: "你以为的都不是真的",
  },
  {
    slug: "anjian",
    name: "案件",
    en: "Case",
    icon: "ri-focus-3-line",
    desc: "连环谜案与离奇凶案，还原最真实的探案现场。",
    tagline: "蛛丝马迹皆是证词",
  },
  {
    slug: "jiemi",
    name: "解密",
    en: "Decode",
    icon: "ri-lock-unlock-line",
    desc: "密码、机关与隐藏秘密，一起揭开尘封的真相。",
    tagline: "解锁被掩埋的真相",
  },
];

export const categoryBySlug = (slug: string): Category | undefined =>
  categories.find((c) => c.slug === slug);